import { lazy, Suspense, type ReactNode } from 'react';
import { useParams, type RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';
import type { CatalogSheetKey } from './CatalogPage';

const CatalogPage = lazy(() => import('./CatalogPage'));
const CatalogSectionPage = lazy(() => import('./CatalogSectionPage'));
const CouponsPage = lazy(() => import('./CouponsPage'));
const CouponFormPage = lazy(() => import('./CouponFormPage'));

/** Sheets da tela principal que também têm endereço próprio (voltar do celular fecha o sheet). */
const SHEETS = new Set<string>(['endereco', 'versao', 'pedidos', 'compartilhar']);

const page = (el: ReactNode) => <Suspense fallback={<PageLoader />}>{el}</Suspense>;

/**
 * /catalogo e /catalogo/:secao na mesma rota: abrir um sheet (endereço, versão,
 * pedidos, compartilhar) não remonta a tela; as demais seções são páginas.
 */
function CatalogRoute() {
  const { secao } = useParams();
  if (!secao || SHEETS.has(secao)) return <CatalogPage sheet={secao as CatalogSheetKey | undefined} />;
  return <CatalogSectionPage secao={secao} />;
}

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  { path: 'catalogo/:secao?', element: page(<CatalogRoute />) },
  { path: 'cupons', element: page(<CouponsPage />) },
  { path: 'cupons/novo', element: page(<CouponFormPage />) },
  { path: 'cupons/:id', element: page(<CouponFormPage />) },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
